/* =========================================================
   LACOLECTIE - CONFIGURATOR AUTO
   =========================================================

   INCLUDE:
   - Progressive disclosure
   - Minimalistă / Detaliată
   - Premium packaging
   - Preview + ATC doar după completarea formularului
   - Styling ATC
   - Loader PASIV pentru procesarea AI

   IMPORTANT:
   - NU modifică funcționalitatea butonului Preview
   - NU ascultă click-ul pe Preview
   - NU declanșează /generate
   - NU modifică imaginea / canvas-ul
   - NU interferează cu cache-ul Customily
   ========================================================= */

(function () {
  if (window.__lcConfiguratorFinal) return;
  window.__lcConfiguratorFinal = true;


  /* =========================================================
     CONFIG
     ========================================================= */

  const GENERATE_ENDPOINT =
    '/service/storefront/image/processing/generate';

  const loaderMessages = [
    'Pregătim fotografia pentru gravură...',
    'Așezăm mașina în design...',
    'Verificăm proporțiile și detaliile...',
    'Punem la punct specificațiile...',
    'Facem ultimele reglaje...',
    'Placheta ta e aproape gata de văzut.'
  ];


  /* =========================================================
     CSS
     ========================================================= */

  const style = document.createElement('style');

  style.textContent = `

    /* ======================================================
       PROGRESSIVE DISCLOSURE
       ====================================================== */

    .customily_section {
  border: 2px dashed #B18A46 !important;
}
       body:not(.lc-photo-open)
      .customily_section:has(.lc-photo-upload),

    body:not(.lc-car-open)
      .customily_section:has(.lc-brand),

    body:not(.lc-engine-open)
      .customily_section:has(.lc-engine),

    body:not(.lc-details-open)
      .customily_section:has(.lc-weight) {
      display: none !important;
    }


    /* Premium packaging:
       nu apare înainte să fie aleasă fotografia */

    body:not(.lc-car-open)
      .customily_section:has(.lc-premium-packaging) {
      display: none !important;
    }


    /* ======================================================
       PREVIEW + ADD TO CART
       ====================================================== */

    /*
      Ambele sunt ascunse până când toate
      câmpurile obligatorii sunt completate.
    */

    body:not(.lc-form-complete)
      #customily-preview-button,

    body:not(.lc-form-complete)
      #customily-cart-btn {
      display: none !important;
    }


    /* Styling ATC */

    #customily-cart-btn {
      background: #D4B56F !important;
      color: #161616 !important;
      border-color: #D4B56F !important;

      font-size: 18px !important;
      font-weight: 700 !important;
    }


    #customily-cart-btn:hover {
      background: #C7A55E !important;
      border-color: #C7A55E !important;
      color: #161616 !important;
    }


    /* ======================================================
       LOADER PASIV
       ====================================================== */

    .lc-preview-loader {
      position: absolute;
      inset: 0;
      z-index: 9999;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      box-sizing: border-box;
      padding: 28px;

      background: rgba(245, 243, 238, .98);

      text-align: center;
    }


    .lc-preview-spinner {
      width: 42px;
      height: 42px;

      margin-bottom: 22px;

      border: 4px solid rgba(177, 138, 70, .22);
      border-top-color: #B18A46;

      border-radius: 50%;

      animation: lcPreviewSpin .8s linear infinite;
    }


    @keyframes lcPreviewSpin {
      to {
        transform: rotate(360deg);
      }
    }


    .lc-preview-message {
      min-height: 50px;
      max-width: 330px;

      display: flex;
      align-items: center;
      justify-content: center;

      color: #161616;

      font-size: 18px;
      font-weight: 700;
      line-height: 1.35;
    }


    .lc-preview-time {
      margin-top: 8px;

      color: #77736b;

      font-size: 13px;
      font-weight: 500;
      line-height: 1.4;
    }


    @media (max-width: 480px) {

      .lc-preview-message {
        font-size: 17px;
      }

    }

  `;

  document.head.appendChild(style);



  /* =========================================================
     HELPERS
     ========================================================= */

  function getFieldValue(selector) {

    const wrapper =
      document.querySelector(selector);

    if (!wrapper) return '';


    const field =
      wrapper.querySelector(
        'input, textarea, select'
      );

    if (!field) return '';


    return String(
      field.value || ''
    ).trim();
  }


  function allCompleted(selectors) {

    return selectors.every(
      selector =>
        getFieldValue(selector) !== ''
    );
  }


  function isDetailedPlaque() {

    const selected =
      document.querySelector(
        '.lc-plaque-type input[type="radio"]:checked'
      );

    if (!selected) {
      return false;
    }


    /*
      MAPPING VERIFICAT DIRECT ÎN DOM-UL LIVE:

      cl-value-id-0 = Cu date tehnice
      cl-value-id-1 = Fără date tehnice
    */

    const id =
      String(
        selected.id || ''
      );


    if (
      id.endsWith(
        '-cl-value-id-0'
      )
    ) {

      return true;

    }


    if (
      id.endsWith(
        '-cl-value-id-1'
      )
    ) {

      return false;

    }


    /*
      Fallback după value, în caz că Customily
      schimbă structura ID-ului în viitor.
    */

    const value =
      String(
        selected.value || ''
      )
        .normalize('NFD')
        .replace(
          /[\u0300-\u036f]/g,
          ''
        )
        .toLowerCase()
        .trim();


    return (
      value === 'cu date tehnice' ||
      value.includes('detaliata')
    );

  }



  /* =========================================================
     PASUL 1
     ALEGERE TIP PLACHETĂ -> FOTOGRAFIE
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const plaqueSection =
        event.target.closest(
          '.customily_section:has(.lc-plaque-type)'
        );


      if (!plaqueSection) return;


      const option =
        event.target.closest(
          'label, input, button, [role="radio"], [role="option"], .customily_option'
        );


      if (!option) return;


      setTimeout(() => {

        document.body.classList.add(
          'lc-photo-open'
        );

      }, 50);

    },
    true
  );


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.closest(
          '.lc-plaque-type'
        )
      ) {

        document.body.classList.add(
          'lc-photo-open'
        );

      }

    },
    true
  );



  /* =========================================================
     PASUL 2
     FOTOGRAFIE -> DESPRE MAȘINA TA
     ========================================================= */

  let photoChosen = false;

  /*
    Customily poate pune upload-ul pe disabled
    și când face alte refresh-uri interne.

    De aceea NU mai considerăm simplul "disabled"
    dovadă că utilizatorul a ales fotografia.

    Fallback-ul disabled este activat DOAR după ce
    utilizatorul a apăsat efectiv upload-ul.
  */

  let photoUploadArmed = false;
  let photoUploadArmTimer = null;


  function disarmPhotoUpload() {

    photoUploadArmed = false;

    clearTimeout(
      photoUploadArmTimer
    );

    photoUploadArmTimer = null;

  }


  function armPhotoUpload() {

    photoUploadArmed = true;


    clearTimeout(
      photoUploadArmTimer
    );


    /*
      Safety:
      nu păstrăm starea activă la nesfârșit.
    */

    photoUploadArmTimer =
      setTimeout(() => {

        disarmPhotoUpload();

      }, 60000);

  }


  function openCarSection() {

    if (photoChosen) return;


    photoChosen = true;


    disarmPhotoUpload();


    document.body.classList.add(
      'lc-car-open'
    );


    evaluateFormCompletion();


    console.log(
      '[LC] Fotografie aleasă -> Despre mașina ta'
    );

  }


  /*
    IMPORTANT:

    Armăm fallback-ul DOAR când utilizatorul
    apasă efectiv butonul de upload al fotografiei.

    Click pe:
    - A6
    - A5
    - Minimalistă
    - Detaliată
    - orice alt element

    NU poate arma upload-ul.
  */

  document.addEventListener(
    'click',
    function (event) {

      const uploadButton =
        event.target.closest(
          '.lc-photo-upload'
        );


      if (uploadButton) {

        armPhotoUpload();

        return;
      }


      /*
        Dacă selectorul fusese armat dar utilizatorul
        revine în pagină și apasă altceva,
        anulăm starea.

        Astfel, schimbarea A6/A5 după anularea
        selectorului de fișiere nu poate produce
        un fals "photo chosen".
      */

      if (
        photoUploadArmed &&
        !photoChosen
      ) {

        disarmPhotoUpload();

      }

    },
    true
  );


  /*
    Varianta ideală:
    dacă există input[type="file"] real și primim
    un fișier, deschidem imediat următorul pas.
  */

  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.matches(
          'input[type="file"]'
        ) &&
        event.target.closest(
          '.customily_section'
        ) &&
        event.target.files?.length
      ) {

        openCarSection();

      }

    },
    true
  );


  /*
    FALLBACK CUSTOMILY

    Customily pune butonul de upload pe disabled
    imediat după alegerea pozei.

    Folosim semnalul DOAR dacă utilizatorul
    apăsase înainte chiar upload-ul fotografiei.
  */

  function checkPhotoUploadState() {

    if (photoChosen) return;

    if (!photoUploadArmed) return;


    const button =
      document.querySelector(
        '.lc-photo-upload'
      );


    if (!button) return;


    const processing =
      button.disabled ||
      button.hasAttribute(
        'disabled'
      ) ||
      button.classList.contains(
        'disabled'
      ) ||
      button.classList.contains(
        'disable-pointer-events'
      );


    if (processing) {

      openCarSection();

    }

  }


  const photoObserver =
    new MutationObserver(
      checkPhotoUploadState
    );


  photoObserver.observe(
    document.body,
    {
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'disabled'
      ]
    }
  );



  /* =========================================================
     PASUL 3
     DESPRE MAȘINA TA -> MOTOR & PERFORMANȚĂ
     ========================================================= */

  /*
    Detaliată:
    anul este obligatoriu.
  */

  const carFields = [
    '.lc-brand',
    '.lc-model',
    '.lc-year',
    '.lc-license-plate'
  ];


  /*
    Minimalistă:
    NU cerem anul.
  */

  const minimalistCarFields = [
    '.lc-brand',
    '.lc-model',
    '.lc-license-plate'
  ];


  function evaluateCarStep() {

    /*
      Minimalistă:
      nu arătăm Motor & performanță.
    */

    if (!isDetailedPlaque()) {

      document.body.classList.remove(
        'lc-engine-open'
      );

      return;
    }


    /*
      Detaliată:
      Motor & performanță apar numai după:
      Marcă + Model + An + Număr.
    */

    if (
      allCompleted(carFields)
    ) {

      document.body.classList.add(
        'lc-engine-open'
      );

    } else {

      document.body.classList.remove(
        'lc-engine-open'
      );

    }

  }



  /* =========================================================
     PASUL 4
     MOTOR & PERFORMANȚĂ -> ULTIMELE DETALII
     ========================================================= */

  const engineFields = [
    '.lc-engine',
    '.lc-power',
    '.lc-torque'
  ];


  function evaluateEngineStep() {

    if (!isDetailedPlaque()) {

      document.body.classList.remove(
        'lc-details-open'
      );

      return;
    }


    if (
      allCompleted(engineFields)
    ) {

      document.body.classList.add(
        'lc-details-open'
      );

    } else {

      document.body.classList.remove(
        'lc-details-open'
      );

    }

  }



  /* =========================================================
     ULTIMELE 3 SPECIFICAȚII OBLIGATORII
     ========================================================= */

  const finalDetailFields = [
    '.lc-weight',
    '.lc-zero-to-hundred',
    '.lc-top-speed'
  ];



  /* =========================================================
     PREVIEW + ATC
     DOAR DUPĂ COMPLETAREA FORMULARULUI
     ========================================================= */

  function evaluateFormCompletion() {

    const plaqueSelected =
      !!document.querySelector(
        '.lc-plaque-type input[type="radio"]:checked'
      );


    /*
      Minimalistă:
      - Marcă
      - Model
      - Număr

      Detaliată:
      - Marcă
      - Model
      - An
      - Număr
    */

    const carReady =
      isDetailedPlaque()
        ? allCompleted(carFields)
        : allCompleted(minimalistCarFields);


    /*
      Ambele variante cer obligatoriu:
      - tip plachetă
      - fotografie
      - datele de bază necesare variantei
    */

    let formComplete =
      plaqueSelected &&
      photoChosen &&
      carReady;


    /*
      Detaliată mai cere obligatoriu:
      - Motor
      - Putere
      - Cuplu
      - Greutate
      - 0–100
      - Viteză maximă
    */

    if (
      formComplete &&
      isDetailedPlaque()
    ) {

      formComplete =
        allCompleted(engineFields) &&
        allCompleted(finalDetailFields);

    }


    document.body.classList.toggle(
      'lc-form-complete',
      formComplete
    );

  }



  /* =========================================================
     INPUT / CHANGE EVENTS
     ========================================================= */

  document.addEventListener(
    'input',
    function (event) {

      if (
        event.target.closest(
          '.lc-brand, .lc-model, .lc-year, .lc-license-plate'
        )
      ) {

        evaluateCarStep();

      }


      if (
        event.target.closest(
          '.lc-engine, .lc-power, .lc-torque'
        )
      ) {

        evaluateEngineStep();

      }


      if (
        event.target.closest(
          '.lc-brand, .lc-model, .lc-year, .lc-license-plate, .lc-engine, .lc-power, .lc-torque, .lc-weight, .lc-zero-to-hundred, .lc-top-speed'
        )
      ) {

        evaluateFormCompletion();

      }

    },
    true
  );


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.closest(
          '.lc-brand, .lc-model, .lc-year, .lc-license-plate'
        )
      ) {

        evaluateCarStep();

      }


      if (
        event.target.closest(
          '.lc-engine, .lc-power, .lc-torque'
        )
      ) {

        evaluateEngineStep();

      }


      if (
        event.target.closest(
          '.lc-brand, .lc-model, .lc-year, .lc-license-plate, .lc-engine, .lc-power, .lc-torque, .lc-weight, .lc-zero-to-hundred, .lc-top-speed'
        )
      ) {

        evaluateFormCompletion();

      }


      /*
        Dacă utilizatorul schimbă între
        Minimalistă și Detaliată.
      */

      if (
        event.target.closest(
          '.lc-plaque-type'
        )
      ) {

        setTimeout(() => {

          evaluateCarStep();
          evaluateEngineStep();
          evaluateFormCompletion();

        }, 50);

      }

    },
    true
  );


  /*
    Stare inițială:
    Preview + ATC sunt ascunse.
  */

  evaluateFormCompletion();



  /* =========================================================
     PREVIEW LOADER PASIV
     =========================================================

     LOGICA:

     Customily face REAL:
     /image/processing/generate

                ↓

     noi afișăm loaderul

                ↓

     requestul REAL se termină

                ↓

     ~2.2 sec pentru WEBP + redraw

                ↓

     loader dispare


     FĂRĂ request /generate:
     codul nostru NU face absolut nimic.
     ========================================================= */

  let activeGenerations = 0;

  let loader = null;
  let loaderMessageTimer = null;
  let loaderFinishTimer = null;
  let loaderSafetyTimer = null;
  let modalObserver = null;



  function findPreviewWrapper() {

    return document.querySelector(
      '.customily-modal-preview-only .canvas-wrapper'
    );

  }



  function createLoader() {

    /*
      Loader doar dacă există procesare REALĂ.
    */

    if (activeGenerations <= 0) return;


    /*
      Nu duplicăm.
    */

    if (loader) return;


    const wrapper =
      findPreviewWrapper();


    /*
      Requestul poate începe înainte să apară
      modalul de Preview.
    */

    if (!wrapper) return;


    wrapper.style.position =
      'relative';


    loader =
      document.createElement('div');


    loader.className =
      'lc-preview-loader';


    loader.innerHTML = `

      <div
        class="lc-preview-spinner"
        aria-hidden="true"
      ></div>


      <div class="lc-preview-message">
        ${loaderMessages[0]}
      </div>


      <div class="lc-preview-time">
        De obicei durează în jur de 20 de secunde.
      </div>

    `;


    wrapper.appendChild(loader);


    let index = 0;


    clearInterval(
      loaderMessageTimer
    );


    loaderMessageTimer =
      setInterval(() => {

        if (!loader) return;


        index =
          (index + 1) %
          loaderMessages.length;


        const message =
          loader.querySelector(
            '.lc-preview-message'
          );


        if (message) {

          message.textContent =
            loaderMessages[index];

        }

      }, 3000);

  }



  function hideLoader() {

    clearInterval(
      loaderMessageTimer
    );

    clearTimeout(
      loaderFinishTimer
    );

    clearTimeout(
      loaderSafetyTimer
    );


    loaderMessageTimer = null;
    loaderFinishTimer = null;
    loaderSafetyTimer = null;


    if (loader) {

      loader.remove();
      loader = null;

    }

  }



  function startModalObserver() {

    if (modalObserver) return;


    /*
      Observerul există DOAR cât Customily
      procesează efectiv imaginea.
    */

    modalObserver =
      new MutationObserver(() => {

        createLoader();

      });


    modalObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    /*
      Dacă modalul există deja.
    */

    createLoader();

  }



  function stopModalObserver() {

    if (!modalObserver) return;


    modalObserver.disconnect();

    modalObserver = null;

  }



  function generationStarted() {

    activeGenerations++;


    clearTimeout(
      loaderFinishTimer
    );


    startModalObserver();


    /*
      Safety absolut.
      Nu poate rămâne blocat pe pagină.
    */

    clearTimeout(
      loaderSafetyTimer
    );


    loaderSafetyTimer =
      setTimeout(() => {

        activeGenerations = 0;

        stopModalObserver();

        hideLoader();

      }, 70000);


    console.log(
      '[LC] Customily generate START'
    );

  }



  function generationFinished() {

    activeGenerations =
      Math.max(
        0,
        activeGenerations - 1
      );


    /*
      Dacă există mai multe requesturi generate
      simultan, așteptăm ultimul.
    */

    if (
      activeGenerations > 0
    ) {
      return;
    }


    /*
      Nu mai avem nevoie să căutăm modalul.
    */

    stopModalObserver();


    /*
      Din testul real:
      /generate s-a terminat,
      apoi WEBP-ul final a mai durat ~1.6 sec.

      Lăsăm 2.2 sec pentru:
      - download WEBP
      - redraw canvas
    */

    clearTimeout(
      loaderFinishTimer
    );


    loaderFinishTimer =
      setTimeout(() => {

        hideLoader();

      }, 2200);


    console.log(
      '[LC] Customily generate END'
    );

  }



  /* =========================================================
     INTERCEPTARE PASIVĂ XHR

     IMPORTANT:
     NU schimbăm requestul.
     NU schimbăm body.
     NU schimbăm headers.
     NU relansăm nimic.

     Doar aflăm:
     "a început /generate"
     "s-a terminat /generate"
     ========================================================= */

  const nativeXHROpen =
    XMLHttpRequest.prototype.open;


  const nativeXHRSend =
    XMLHttpRequest.prototype.send;



  XMLHttpRequest.prototype.open =
    function (
      method,
      url,
      ...rest
    ) {

      this.__lcGenerateRequest =
        (
          typeof url === 'string' &&
          url.includes(
            GENERATE_ENDPOINT
          )
        );


      return nativeXHROpen.call(
        this,
        method,
        url,
        ...rest
      );

    };



  XMLHttpRequest.prototype.send =
    function (...args) {


      if (
        this.__lcGenerateRequest
      ) {

        generationStarted();


        this.addEventListener(
          'loadend',
          generationFinished,
          {
            once: true
          }
        );

      }


      return nativeXHRSend.apply(
        this,
        args
      );

    };


  console.log(
    '[LC] Configurator final activ'
  );

})();